import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import { useVariationContext } from '../../contexts/VariationContext';

/**
 * Modal component for confirming variation deletion
 * 
 * @param {Object} props - Component props
 * @param {Object} props.selectedVariation - The selected variation
 * @param {Function} props.onConfirmDelete - Function to handle deletion confirmation
 * @returns {JSX.Element} DeleteConfirmationModal component
 */
const DeleteConfirmationModal = React.memo(({
  selectedVariation,
  onConfirmDelete
}) => {
  const { uiState, setShowDeleteModal } = useVariationContext();
  const { showDeleteModal } = uiState;

  // Handler for cancel button
  const handleCancel = React.useCallback(() => {
    setShowDeleteModal(false);
  }, [setShowDeleteModal]);

  return (
    <Modal open={showDeleteModal} size="small">
      <Modal.Header>
        Delete Variation - {selectedVariation?.name || 'Unnamed Variation'}
      </Modal.Header>
      <Modal.Content>
        <p>
          Are you sure you want to delete this variation - {selectedVariation?.name || 'Unnamed Variation'}?
          This action cannot be undone.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={() => {
          // First close the modal
          setShowDeleteModal(false);
          // Then call the delete handler
          onConfirmDelete();
        }}>
          Delete
        </Button>
        <Button onClick={handleCancel}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
});

// Add display name for debugging
DeleteConfirmationModal.displayName = 'DeleteConfirmationModal';

export default DeleteConfirmationModal;
